import type { LocationQueryValue } from 'vue-router';

/** First value of a route query param, or null. */
export function queryString(value: LocationQueryValue | LocationQueryValue[] | undefined): string | null {
  const v = Array.isArray(value) ? value[0] : value;
  return v || null;
}
